import { useFollow } from "@/hooks/useFollow";

export function FollowButton({ companyId }: { companyId: string }) {
  const { isFollowing, loading, toggle } = useFollow(companyId);

  return (
    <button
      onClick={toggle}
      disabled={loading}
      className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
        isFollowing
          ? "bg-zinc-800 text-zinc-300 hover:bg-zinc-700"
          : "bg-orange-600 text-white hover:bg-orange-500"
      } disabled:opacity-50`}
    >
      {loading ? "..." : isFollowing ? "Following ✓" : "+ Follow"}
    </button>
  );
}
